import * as types from './actionTypes'
import { employeeLeaveService } from '../_services'
import { toast } from 'react-toastify'

toast.configure()

export function fetchEmployeeLeave(options) {
    return function(dispatch) {
        return employeeLeaveService
            .fetchEmployeeLeave(options)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_EMPLOYEE_LEAVE, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_EMPLOYEE_LEAVE_FAILURE, error }
    }
}

export function fetchEmployeeLeaveWeekly(options) {
    return function(dispatch) {
        return employeeLeaveService
            .fetchEmployeeLeave(options)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_EMPLOYEE_LEAVE_WEEKLY, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_EMPLOYEE_LEAVE_FAILURE, error }
    }
}

export function updateCurrentDate(cond) {
    return dispatch => {
        return dispatch({ type: types.UPDATE_CURRENT_DATE, payload: cond })
    }
}

export function updateDisplayLeave(cond) {
    return dispatch => {
        return dispatch({ type: types.UPDATE_DISPLAY_LEAVE, cond: cond })
    }
}